"use client"

import { useState, useEffect } from "react"

const RolexClock = ({style}) => {
  const [isGmtClicked,setGmtClicked]= useState(true)
  const [isLocalClicked,setLocalClicked]= useState(false)
  const [time, setTime] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
    localTimeString: "00:00",
    gmtTimeString: "00:00",
  })

  const [isMobile, setIsMobile] = useState(false)

  // Handle responsive layout
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
    }

    // Set initial value
    handleResize()

    // Add event listener
    window.addEventListener("resize", handleResize)

    // Clean up
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  // Update clock
  useEffect(() => {
    const updateClock = () => {
      const now = new Date()

      // Get hours, minutes, and seconds
      const hours = now.getUTCHours() % 12
      const minutes = now.getUTCMinutes()
      const seconds = now.getUTCSeconds()

      // Format time strings
      const localHours = now.getHours().toString().padStart(2, "0")
      const localMinutes = now.getMinutes().toString().padStart(2, "0")
      const localTimeString = `${localHours}:${localMinutes}`

      const gmtHours = now.getUTCHours().toString().padStart(2, "0")
      const gmtMinutes = now.getUTCMinutes().toString().padStart(2, "0")
      const gmtTimeString = `${gmtHours}:${gmtMinutes}`

      setTime({
        hours,
        minutes,
        seconds,
        localTimeString,
        gmtTimeString,
      })
    }

    // Initial update
    updateClock()

    // Set interval for updates
    const intervalId = setInterval(updateClock, 1000)

    // Clean up
    return () => clearInterval(intervalId)
  }, [])

  // Calculate rotation angles
  const hourDegrees = time.hours * 30
  const minuteDegrees = time.minutes * 6
  const secondDegrees = time.seconds * 6

  return (
    <div className={`${style} bg-[#00573f]   py-2 flex justify-center items-center text-white px-8  `}>
      <div
        className={`flex  items-center justify-center w-full max-w-7xl gap-3 md:gap-4`}
      >
        {/* Rolex Logo */}
        <div className={`w-[80px] h-auto ${isMobile ? "mb-4" : "order-1"}`}>
          <svg id="rolex-logo" viewBox="0 0 266.7 156.1">
            <g>
              <g>
                <g>
                  <path
                    fill="#c0911e"
                    d="M103.1,34.2c0.4,0,0.7-0.1,1.1-0.1l12.7,43.2h0c1.4,4.8,8.4,8.5,16.9,8.5c8.5,0,15.5-3.7,16.9-8.5h0
                    l12.7-43.2c0.3,0.1,0.6,0.1,1,0.1c2.5,0,4.5-2,4.5-4.5c0-2.5-2-4.5-4.5-4.5c-2.5,0-4.5,2-4.5,4.5c0,1.8,1,3.3,2.5,4l-14.7,31.6
                    l2.4-42.5c0,0,0.1,0,0.1,0c2.5,0,4.5-2,4.5-4.5c0-2.5-2-4.5-4.5-4.5c-2.5,0-4.5,2-4.5,4.5c0,2,1.4,3.7,3.2,4.3l-9.8,41.6
                    l-4.7-45.8c2.2-0.3,3.8-2.2,3.8-4.4c0-2.5-2-4.5-4.5-4.5c-2.5,0-4.5,2-4.5,4.5c0,2.3,1.7,4.1,3.9,4.4l-4.7,45.7l-9.8-41.5
                    c1.9-0.5,3.3-2.2,3.3-4.3c0-2.5-2-4.5-4.5-4.5c-2.5,0-4.5,2-4.5,4.5c0,2.5,2,4.5,4.5,4.5c0,0,0,0,0.1,0l2.4,42.5l-14.7-31.6
                    c1.4-0.7,2.4-2.2,2.4-4c0-2.5-2-4.5-4.5-4.5c-2.5,0-4.5,2-4.5,4.5C98.6,32.2,100.6,34.2,103.1,34.2z M133.7,73.6
                    c7.7,0,14,2,14,4.4c0,2.4-6.3,4.4-14,4.4c-7.7,0-14-2-14-4.4C119.7,75.6,126,73.6,133.7,73.6z"
                  />
                  <g>
                    <path
                      fill="#FFFFFF"
                      d="M84.4,103.8c-12.8,0-23.2,10.4-23.2,22.9c0,12.5,10.4,22.9,23.2,22.9c12.8,0,23.2-10.4,23.2-22.9
                      C107.6,114.2,97.2,103.8,84.4,103.8z M94,139.9c-0.7,1.1-1.6,2-2.7,2.8c-1.7,1.4-3.7,2.2-5.8,2.2c-0.4,0-0.8,0.1-1.2,0.1
                      c-0.4,0-0.8,0-1.2-0.1c-2.1-0.1-4-0.9-5.7-2.2c-1.1-0.8-2-1.7-2.7-2.8c-2.4-3.3-3.9-8-3.9-13.2c0-4.9,1.3-9.3,3.5-12.5
                      c1.2-2.2,3.1-3.9,5.4-4.9c0,0,0,0,0.1,0c0.1,0,0.2-0.1,0.3-0.1c0.3-0.1,0.6-0.2,0.9-0.3c1.1-0.3,2.2-0.5,3.3-0.5
                      c1.2,0,2.3,0.2,3.3,0.5c0.3,0.1,0.6,0.2,0.9,0.3c0.1,0,0.2,0.1,0.3,0.1c0,0,0,0,0.1,0c2.3,1,4.2,2.7,5.4,4.9
                      c2.2,3.3,3.5,7.7,3.5,12.5C97.9,131.9,96.4,136.6,94,139.9z"
                    />
                    <path
                      fill="#FFFFFF"
                      d="M153.5,131.5h-3.2v6.4c-0.1,3.9-3.2,7-7.1,7c0,0,0,0,0,0v0h-9.8h-3.7v-36.3h6.2v-3.2h-6.2l0,0h-0.7h-15.5
                      v3.2h6.2v36.3h-6.2v3.2h36.9h2.7h0.3h0.2v0h0v-10.5h0V131.5z"
                    />
                    <path
                      fill="#FFFFFF"
                      d="M202.5,105.5L202.5,105.5h-0.3h-9.9h-32v3.2h6.1v36.3h-6.1v3.2v0h32h7.2h2.8h0.2h0h0.2v-10.5v-4.8h-3.2v5.1
                      l0,0c0,3.9-3.2,7.1-7.1,7.1c0,0,0,0,0,0v0h-11.5v0h-4.3h-0.1v-17.4V127h3.2c0,0,0.1,0,0.1,0h1.8l0,0c2.9,0,5.2,2.4,5.2,5.3
                      c0,0,0,0.1,0,0.1h0v1.7l0,0v0.7h2.9v-0.4V127v0v-2.6v0V117v-0.1h-2.9v2.1h0c0,0,0,0.1,0,0.1c0,2.9-2.3,5-5.2,5l0,0h-1.9h-2h-1.2
                      v-15.3h0.1h9.2c0,0,0.1,0,0.1,0h6.6c3.9,0,7.1,3.2,7.1,7.1l0,0v4.4h3.2V116v-10.5v0H202.5z"
                    />
                    <path
                      fill="#FFFFFF"
                      d="M257.9,145.1c-3.1-0.1-3.8-1-6.2-3.8l-14.1-17.6l9.4-11.2v0c2.5-2.9,3.2-3.9,6.4-3.9h2h0.4v-3.1h-0.4h-9.2
                      h-0.4H239h-0.4v3.1h0.4h3.4v0c0,0,0,0,0,0c0.8,0,1.5,0.6,1.5,1.5c0,0.3-0.1,0.6-0.3,0.9l-8.3,9.9l-6.5-8.1l-1.4-1.7
                      c-0.2-0.3-0.3-0.6-0.3-0.9c0-0.8,0.7-1.5,1.5-1.5h3.7v-3.1h-6.6H216h-5.3v3.1h1c2.8,0.1,3.5,1.1,5.7,3.5l12.5,15.6l-11.3,13.5v0
                      c-2.5,2.9-3.2,3.9-6.4,3.9h-2h-0.7v3.1h0.7h10.7h0.7h5.8h0.7v-3.1h-0.7h-3.9v0c0,0,0,0,0,0c-0.8,0-1.5-0.6-1.5-1.5
                      c0-0.3,0.1-0.7,0.3-0.9l10-11.9l8.3,10.4l1.3,1.6c0.2,0.3,0.3,0.6,0.3,0.9c0,0.8-0.7,1.5-1.5,1.5c0,0,0,0,0,0l0,0h-4v3.1h0v0
                      H260v-3.1H257.9z"
                    />
                  </g>
                </g>
              </g>
              <path
                fill="#FFFFFF"
                d="M53.9,144.9l-2.8-8.2c-1.3-3.7-2.3-5.3-4.3-7.2c-1.4-1.2-3.3-1.8-4.7-2.2c5.3-0.8,9.3-5.4,9.3-10.9
                c0-6.1-4.9-11-11-11c-0.1,0-0.1,0-0.2,0v0H23.5h-10h-6v3.2h6v36.3H7.4v3.2h16l0,0h6.2v-3.2h-6.1v-17.4h4.8c0.2,0,0.3,0,0.4,0h1
                c1.5,0.1,2.8,0.3,4,0.6c1.1,0.3,2.3,0.7,3,1.2c1.1,0.7,2.2,1.6,3.2,3.3c0.3,0.4,0.5,0.9,0.7,1.3c1.8,3.4,2.9,8.2,4.1,14.2h7.3v0
                h6.6v-3.2H53.9z M33.9,124.2H23.5v-15.6h10.4c4.5,0.2,8.1,3.3,8.1,7.8C42,120.9,38.4,124,33.9,124.2z"
              />
            </g>
          </svg>
        </div>

        {/* Clock */}
        <div className={`relative w-[65px] h-[65px] my-4 ${isMobile ? "" : "order-2"}`}>
          <div className="relative w-full h-full">
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/80-N3AScM813m2lgFdijDUWXihbgWsZ5j.png"
              alt="Rolex Watch Face"
              className="absolute top-0 left-0 w-full h-full"
            />
            <div
              className="absolute bottom-1/2 left-1/2 w-[2px] h-[15px] bg-[#0f3c03] rounded-sm z-10 origin-bottom"
              style={{ transform: `translateX(-50%) rotate(${hourDegrees}deg)` }}
            ></div>
            <div
              className="absolute bottom-1/2 left-1/2 w-[1.5px] h-[22px] bg-[#0f3c03] rounded-sm z-10 origin-bottom"
              style={{ transform: `translateX(-50%) rotate(${minuteDegrees}deg)` }}
            ></div>
            <div
              className="absolute bottom-1/2 left-1/2 w-[1px] h-[26px] bg-nav_gold rounded-sm z-10 origin-bottom"
              style={{ transform: `translateX(-50%) rotate(${secondDegrees}deg)` }}
            ></div>
          </div>
        </div>

        {/* Time Display */}
        <div className={`flex flex-col  text-[10px]  text-start items-start ${isMobile ? "" : "order-3 mt-0"}`}>
          <div className="flex flex-col items-center justify-center relative ">
            <span className=" font-bold text-nav_gold">GMT</span>
            <div className=" font-bold text-nav_gold">{time.gmtTimeString}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RolexClock
